/*
 * TerriSTORY®
 *
 © Copyright 2022 AURA-EE
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * A copy of the GNU Affero General Public License should be present along
 * with this program at the root of current repository. If not, see
 * http://www.gnu.org/licenses/.
 */

import React from "react";
import { Link } from "react-router-dom";
import MDEditor from "@uiw/react-md-editor";
import Api from "../../Controllers/Api.js";
import config from "../../settings.js";
import { consulteAutrePage } from "../../utils.js";
import SEO from "../SEO.js";
import Loading from "../../wrappers/Loading.js";

/**
 * This component is used to to display the legal notices relating to the selected region
 */
class OpenSource extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      changelog: undefined,
      lastVersion: undefined,
      lastVersionDate: undefined
    };
  }
  componentDidMount() {
    let region = this.props.parentApi.data.region;
    let idUtilisateur = this.props.parentApi.data && this.props.parentApi.controller.gestionSuiviConsultations ? this.props.parentApi.controller.gestionSuiviConsultations.idUtilisateur : 0;
    let url = config.api_consultation_autre_page_url;
    if (region) consulteAutrePage(url, region, idUtilisateur, "Open-Source", "");
    if (this.state.changelog === undefined) {
      Api.callApi(config.changelog_url).then(json => {
        this.setState({
          changelog: json["content"],
          lastVersion: json["last_version"],
          lastVersionDate: json["last_version_date"]
        });
      });
    }
  }
  render() {
    if (!this.props.parentApi.data.settings) {
      return /*#__PURE__*/React.createElement(Loading, {
        isLoaded: this.props.parentApi.data.settings && Object.values(this.props.parentApi.data.settings).length > 0
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "widgets full-screen-widget"
    }, /*#__PURE__*/React.createElement(SEO, {
      settings: this.props.parentApi.data.settings["seo"],
      page: "open-source"
    }), !this.props.hideBackToMap && /*#__PURE__*/React.createElement(Link, {
      className: "back-to-map",
      to: "/" + this.props.parentApi.data.urlPartageable
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "close close-big",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }, /*#__PURE__*/React.createElement("span", {
      "aria-hidden": "true"
    }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
      className: "tout"
    }, /*#__PURE__*/React.createElement("div", {
      className: "img larger-logo"
    }, /*#__PURE__*/React.createElement("img", {
      src: "../../img/logo_TerriSTORY_transparent.png",
      alt: "Logo de TerriSTORY\xAE"
    })), /*#__PURE__*/React.createElement("div", {
      className: "texte-corps"
    }, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h1", {
      className: "title-referencement-a-propos"
    }, "Politique Open-Source"), /*#__PURE__*/React.createElement("h3", {
      className: "a-propos"
    }, "Informations g\xE9n\xE9rales"), /*#__PURE__*/React.createElement("p", null, "TerriSTORY\xAE, initi\xE9 par Auvergne-Rh\xF4ne-Alpes Energie Environnement est port\xE9 depuis d\xE9but 2020 par un consortium d'acteurs de niveau r\xE9gional et national. Tous ces acteurs ayant une mission de service public ou d'int\xE9r\xEAt g\xE9n\xE9ral, ils ont d\xE9cid\xE9 de passer TerriSTORY\xAE en open-source. Cette ouverture a notamment pour objectif de faciliter les \xE9volutions de l'outil, pour r\xE9pondre de mieux en mieux au besoin des territoires de pilotage de leur trajectoire de transition."), /*#__PURE__*/React.createElement("p", null, "Le code source est ainsi rendu disponible sur le site gitlab \xE0 l'adresse", " ", /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      rel: "noreferrer",
      href: "https://gitlab.com/terristory/terristory"
    }, "https://gitlab.com/terristory/terristory"), " ", "sous la licence aGPL-v3 disponible sur", " ", /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      rel: "noreferrer",
      href: "https://gitlab.com/terristory/terristory/-/blob/master/LICENSE.md"
    }, "le d\xE9p\xF4t git"), "."), /*#__PURE__*/React.createElement("p", null, "Vous pouvez contribuer \xE0 faire \xE9voluer TerriSTORY\xAE de plusieurs fa\xE7ons :"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "En signalant tout probl\xE8me, bug, comportement inhabituel ou non d\xE9sirable sur", " ", /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      rel: "noreferrer",
      href: "https://gitlab.com/terristory/terristory/-/issues/new?issuable_template=bug_report"
    }, "ce lien")), /*#__PURE__*/React.createElement("li", null, "En proposant une piste d'am\xE9lioration ou une nouvelle fonctionnalit\xE9 sur", " ", /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      rel: "noreferrer",
      href: "https://gitlab.com/terristory/terristory/-/issues/new?issuable_template=new_feature"
    }, "ce lien"))), /*#__PURE__*/React.createElement("p", null, "Attention, avant de signaler un bug ou de proposer une am\xE9lioration, pensez \xE0 bien vous assurer qu'un autre ticket n'a pas d\xE9j\xE0 \xE9t\xE9 cr\xE9\xE9 dans la", " ", /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      rel: "noreferrer",
      href: "https://gitlab.com/terristory/terristory/-/issues"
    }, "base disponible sur gitlab"), " ", "pour le m\xEAme probl\xE8me ou la m\xEAme id\xE9e."), /*#__PURE__*/React.createElement("h3", {
      className: "a-propos"
    }, "Si vous \xEAtes d\xE9veloppeur"), /*#__PURE__*/React.createElement("p", null, "La documentation technique du projet est disponible sur", " ", /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      rel: "noreferrer",
      href: "https://docs.terristory.fr/"
    }, "https://docs.terristory.fr/"), ". Elle inclut notamment :"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "le", " ", /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      rel: "noreferrer",
      href: "https://docs.terristory.fr/installation.html"
    }, "guide d'installation")), /*#__PURE__*/React.createElement("li", null, "la", " ", /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      rel: "noreferrer",
      href: "https://docs.terristory.fr/notice_contribution.html"
    }, "notice de contribution")), /*#__PURE__*/React.createElement("li", null, "la", " ", /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      rel: "noreferrer",
      href: "https://docs.terristory.fr/architecture_logicielle.html"
    }, "description technique du syst\xE8me")), /*#__PURE__*/React.createElement("li", null, "quelques", " ", /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      rel: "noreferrer",
      href: "https://docs.terristory.fr/tools.html"
    }, "outils pratiques"))), /*#__PURE__*/React.createElement("p", null, "Si vous souhaitez soumettre vos modifications ou vos ajouts au projet principal de TerriSTORY\xAE, il vous faudra passer par une ", /*#__PURE__*/React.createElement("em", null, "fork"), " puis par une", " ", /*#__PURE__*/React.createElement("em", null, "demande de fusion"), " ou ", /*#__PURE__*/React.createElement("em", null, "pull request"), ". Dans ce cas, vous serez contact\xE9(e) par AURA-EE, propri\xE9taire du code source de la plateforme, pour proc\xE9der \xE0 la signature :"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "d'un document certifiant que vous \xEAtes bien \xE0 l'origine du code et que vous disposez des droits n\xE9cessaires. Ce document, appel\xE9", " ", /*#__PURE__*/React.createElement("em", null, "Developer Certificate of Origin"), " (DCO), est", " ", /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      rel: "noreferrer",
      href: "https://gitlab.com/terristory/terristory/-/blob/master/docs/legal/dco.md"
    }, "accessible \xE0 l'adresse suivante"), "."), /*#__PURE__*/React.createElement("li", null, "d'un document dans lequel vous c\xE9dez la propri\xE9t\xE9 de votre code au propri\xE9taire de TerriSTORY\xAE, AURA-EE. Ce document est", " ", /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      rel: "noreferrer",
      href: "https://gitlab.com/terristory/terristory/-/blob/master/docs/legal/cla.md"
    }, "accessible \xE0 l'adresse suivante"), ".")), /*#__PURE__*/React.createElement("h1", {
      className: "title-referencement-a-propos"
    }, "Derniers changements"), this.state.lastVersion && /*#__PURE__*/React.createElement("p", null, "La derni\xE8re version est la", " ", /*#__PURE__*/React.createElement("strong", null, "version ", this.state.lastVersion), " (voir", " ", /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      rel: "noreferrer",
      href: "https://gitlab.com/terristory/terristory/-/tree/prod-" + this.state.lastVersion
    }, "ici pour le code source"), ") qui date approximativement du", " ", /*#__PURE__*/React.createElement("em", null, this.state.lastVersionDate), "."), /*#__PURE__*/React.createElement("div", {
      className: "markdown-changelog"
    }, /*#__PURE__*/React.createElement(MDEditor.Markdown, {
      source: this.state.changelog
    })))));
  }
}
export default OpenSource;